import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import {
  EmmaIcon,
  EmmaListWithIcon,
  EmmaSpace,
  EmmaText,
  SmallButton,
} from '@axa-asia/emma-stylesheet';
import Step from '@axa-asia/emma-stylesheet/lib/components/Step/Step';
import classNames from 'classnames';
import _ from 'lodash';
import React, { Component } from 'react';
import Slider from 'react-slick';
import uuidv4 from 'uuid/v4';
import { goto, pushTitle } from '../../../../actions/historyActions';
import {
  putOpenEmmaContactCallModel,
  putOpenEmmaTncStyleModel,
} from '../../../../actions/uiActions';
import documentIcon from '../../../../assets/images/document@3x.png';
import LoadingView from '../../../../components/LoadingView';
import {
  GeneralFeatureIds,
  WINDOW_SIZE,
} from '../../../../constants/constants';
import { t } from '../../../../locales';
import {
  downloadDocument,
  openDisclaimer,
} from '../../../../modules/emma-common/actions';
import {
  getProfileFeatures,
  isCWP,
} from '../../../../modules/home/selectors/serviceSelectors';
import {
  CardViewPrivilegesBannersState,
  CardViewPrivilegesSectionsState,
  CardViewPrivilegesServiceCardState,
  CardViewState,
} from '../../../../modules/myPrivileges/reducers';
import {
  getCardViewPrivilegesState,
  getCustomerStateUrl,
  getIsLoadingCtnButtonState,
  getOfferCardViewPrivilegesState,
} from '../../../../modules/myPrivileges/selectors/myPrivilegesSelector';
import { OFFER_SUBMITTED_FORM_CUST_KEY } from '../../../../modules/offers/constants';
import { getToken } from '../../../../selectors/authSelectors';
import { select } from '../../../../stores';
import {
  getValidToken,
  isApp,
  resolveLocalizedText,
  resolvePublicAssets,
} from '../../../../utils';
import {
  getGaPagePath,
  handleGaError,
} from '../../../../utils/generalGaEventAnalytics';
import { myAxaFetchWithToken } from '../../../../utils/myAxaFetchWithToken';
import { windowSize } from '../../../../utils/window';
import {
  updateOffersForm,
  updateOffersFormResponse,
} from '../../../offers/actions/offersFormAction';
import OfferDetailBanner from '../../../offers/components/OfferDetailBanner/OfferDetailBanner';
import {
  fetchDetailsPageInfo,
  goTo,
  openMyPrivilegesDisclaimer,
  setPageLoading,
  setPageNotLoading,
  toggleModelDisplay,
  triggerCTAButton,
} from '../../actions/myPrivilegesAction';
import { Dropdown } from '../Dropdown';
import { Ellipses } from '../Ellipses';
import { MediaPlayer } from '../MediaPlayer';
import MyPrivilegesModalView from '../MyPrivilegesModalView';
import { ServiceSection } from '../ServiceSection';
import './styles.scss';

export type PrivilegesDetailsProps = {
  isLoadingPage: boolean;
  title?: string;
  subtitle?: string;
  subjectDesc?: string;
  supportDesc?: string;
  ctaBtnText?: string;
  openingHoursDisplay?: string;
  summaryTitle?: string;
  summary?: string;
  more?: string;
  less?: string;
  enquiry?: string;
  enquiryDesc?: string;
  enquiryDesc2?: string;
  enquiryDesc3?: string;
  banner: any;
  tel?: string;
  tel2?: string;
  stepSection?: any;
  stepSection2?: any;
  section: Array<any>;
  icon?: string;
  contactNumber?: string;
  signalModel?: string;
  disclaimerId?: string;
  disclaimerLockId?: string;
  url: string;
  btnText: any;
  profileFeatures?: Array<string>;
  termsCondition?: string;
  termsConditionDesc?: string;
  termsConditionTncId?: string;
  termsConditionTncDesc?: string;
  termsConditionDesc2?: string;
  termsConditionTncId2?: string;
  termsConditionTncDesc2?: string;
  termsConditionDesc3?: string;
  isLoadingCtnButton?: boolean;
  morePrivileges?: string;
  morePrivilegesTab?: string;
  morePrivilegesDesc?: string;
  morePrivilegesBtnText?: string;
  priceLists?: [];
  priceListTitle?: string;
  priceListDesc?: string;
  priceListLabel?: string;
  priceListLink?: string;
  isOffer?: boolean;
  isCtaEnabled?: boolean;
  image?: string;
  imageTitle?: string;
  imageDesc?: string;
  customerStateUrl: string;
  submittedFormKey?: string;
  alreadyEnrolled: string;
  promotionEnded: string;
  serviceTitle?: string;
  serviceCards?: Array<CardViewPrivilegesServiceCardState>;
  buttonRemarkTitle?: string;
  buttonRemarkContent?: string;
  buttonRemarkIcon?: string;
  buttonRemarkBtnText?: string;
  buttonRemarkDeepLink?: string;
};

export interface GenericDetailsViewProps {
  cardViewId: string;
  reducerSubName?: string;
  isLocked?: boolean;
  serviceSection: any;
  featureId: string;
  lang: string;
  onPushTitle: (title: string) => void;
  onClickTryNow: (
    cardViewId: string,
    isLocked: boolean,
    obj: {
      url: string;
      disclaimerId?: string;
      disclaimerLockId?: string;
      contactNumber?: string;
      signalModel?: string;
    },
    profileFeatures?: Array<string>,
  ) => void;
  privilegesDetails: PrivilegesDetailsProps;
  onClickModuleCard: (cardId: string) => void;
  openEmmaTncStyleModel: (disclaimerId: string) => void;
  onDownloadDocument: (url: string) => void;
  onFetchDetailsPageInfo: () => void;
  onEndLoadingPage: () => void;
  setPageLoading: () => void;
}

const blueArrowRightIcon = resolvePublicAssets(
  '/assets/images/blue-arrow-right.png',
);
const greyArrowRightIcon = resolvePublicAssets(
  '/assets/images/grey-arrow-right.png',
);

export class GenericDetailsView extends Component<
  GenericDetailsViewProps,
  CardViewState
> {
  constructor(props: any = {}) {
    super(props);
    this.state = {
      isFetchingStage: false,
      isCustomerStateDisable: false,
      windowSize: WINDOW_SIZE.LARGE,
      hideBannerCaption: {},
      stageName: '',
      privilegesDetailsData: {},
    };
  }

  componentDidMount() {
    const { onPushTitle, cardViewId, privilegesDetails } = this.props;
    const { submittedFormKey, subtitle } = privilegesDetails;
    onPushTitle('');
    this.onClickToGatc = this.onClickToGatc.bind(this);
    if (submittedFormKey) {
      this.setState({ isCustomerStateDisable: true });
      this.loadCustomerState().then((res) => {
        try {
          if (res && typeof res === 'string') {
            const { sportsPaOfferForm } = JSON.parse(res);
            this.setState({ isCustomerStateDisable: sportsPaOfferForm });
          } else {
            this.setState({ isCustomerStateDisable: false });
          }
        } catch (err) {
          console.error(err);
        }
      });
    }
    try {
      const _this = this;
      const form1: any = document.getElementById(
        'my_privileges_offers_document_form_1',
      );
      const form2: any = document.getElementById(
        'my_privileges_offers_document_form_2',
      );
      const form3: any = document.getElementById(
        'my_privileges_offers_document_form_3',
      );
      const form4: any = document.getElementById(
        'my_privileges_offers_document_form_4',
      );
      if (form1) {
        form1.onclick = function (e: any) {
          _this.onGaTaggingClick(cardViewId, subtitle, this.innerHTML);
        };
        form1.setAttribute('data-enable-ga', 'true');
        form1.setAttribute('data-ga-type', 'link');
      }
      if (form2) {
        form2.onclick = function (e: any) {
          _this.onGaTaggingClick(cardViewId, subtitle, this.innerHTML);
        };
        form2.setAttribute('data-enable-ga', 'true');
        form2.setAttribute('data-ga-type', 'link');
      }
      if (form3) {
        form3.onclick = function (e: any) {
          _this.onGaTaggingClick(cardViewId, subtitle, this.innerHTML);
        };
        form3.setAttribute('data-enable-ga', 'true');
        form3.setAttribute('data-ga-type', 'link');
      }
      if (form4) {
        form4.onclick = function (e: any) {
          _this.onGaTaggingClick(cardViewId, subtitle, this.innerHTML);
        };
        form4.setAttribute('data-enable-ga', 'true');
        form4.setAttribute('data-ga-type', 'link');
      }
    } catch (e) {
      console.log(e);
    }

    window.addEventListener('resize', this.updateWindowSize);
    this.updateWindowSize();

    this.props.onFetchDetailsPageInfo();
  }

  updateWindowSize = () => {
    this.setState({
      windowSize: windowSize(),
    });
  };

  loadCustomerState = async () => {
    const { customerStateUrl = '' } = this.props.privilegesDetails;
    try {
      const result = await myAxaFetchWithToken(
        `${customerStateUrl}?channel=emma&custKey=${OFFER_SUBMITTED_FORM_CUST_KEY}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-axahk-msgid': uuidv4(),
          },
        },
      );
      const data = await result.json();
      return data && data.length > 0 ? data[0].custValue : false;
    } catch (ex) {
      throw ex;
    }
  };

  onClickToGatc(cardViewId: string, ctaBtnText?: string, subtitle?: string) {
    const tcWindow: any = window;
    const token = select(getToken);
    const aToken = getValidToken(token);
    // ga#MP7
    try {
      tcWindow.dataLayer.push({
        event: 'serviceButtonClicked',
        serviceButton: ctaBtnText ? ctaBtnText : '',
        serviceName: subtitle ? subtitle : '',
        serviceId: cardViewId,
        screenName: getGaPagePath(),
        AXAID: aToken,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (!isApp()) {
      //   tcWindow.tC.event.servicesOpen(tcWindow, {
      //     serviceButton: ctaBtnText ? ctaBtnText : '',
      //     serviceName: subtitle ? subtitle : '',
      //     serviceId: cardViewId,
      //     page: getGaPagePath(),
      //   });
      // }
    } catch (e) {
      handleGaError(e);
    }
  }

  onGaTaggingClick(
    cardViewId: string,
    subtitle?: string,
    displayedButtonText?: string,
  ) {
    const tcWindow: any = window;
    const token = select(getToken);
    const aToken = getValidToken(token);
    // ga#WP11
    try {
      tcWindow.dataLayer.push({
        event: 'clickServiceIntro',
        serviceName: subtitle ? subtitle : '',
        serviceId: cardViewId,
        displayedButtonText: displayedButtonText,
        screenName: getGaPagePath(),
        userId: aToken,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (!isApp()) {
      //   tcWindow.tC.event.clickServiceIntro(tcWindow, {
      //     serviceName: subtitle ? subtitle : '',
      //     serviceId: cardViewId,
      //     displayedButtonText: displayedButtonText,
      //     screenName: getGaPagePath(),
      //     AXAID: aToken,
      //   });
      // }
    } catch (e) {
      handleGaError(e);
    }
  }

  render() {
    const {
      cardViewId,
      isLocked,
      privilegesDetails,
      onClickTryNow,
      onClickModuleCard,
      onDownloadDocument,
      openEmmaTncStyleModel,
      lang,
    } = this.props;
    const {
      isLoadingPage,
      title,
      subtitle,
      subjectDesc,
      supportDesc,
      ctaBtnText,
      openingHoursDisplay,
      summaryTitle,
      summary,
      more,
      less,
      banner,
      disclaimerId,
      disclaimerLockId,
      url,
      signalModel,
      section,
      stepSection,
      stepSection2,
      enquiry,
      enquiryDesc,
      enquiryDesc2,
      enquiryDesc3,
      tel,
      tel2,
      contactNumber,
      icon,
      profileFeatures,
      termsCondition,
      termsConditionDesc,
      termsConditionTncId,
      termsConditionTncDesc,
      termsConditionDesc2,
      termsConditionTncId2,
      termsConditionTncDesc2,
      termsConditionDesc3,
      isLoadingCtnButton,
      morePrivileges,
      morePrivilegesTab,
      morePrivilegesDesc,
      morePrivilegesBtnText,
      priceListTitle,
      priceLists,
      priceListDesc,
      priceListLabel,
      priceListLink,
      isOffer,
      isCtaEnabled,
      image,
      imageTitle,
      imageDesc,
      alreadyEnrolled,
      promotionEnded,
      serviceTitle,
      serviceCards,
      buttonRemarkTitle,
      buttonRemarkContent,
      buttonRemarkIcon,
      buttonRemarkBtnText,
      buttonRemarkDeepLink,
    } = this.state.privilegesDetailsData.banner
      ? this.state.privilegesDetailsData
      : this.props.privilegesDetails;
    const link = `emma-my-privileges/details-view/mannings?manning_from=appointment`;
    const settings = {};
    const defaultSettings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      cssEase: 'linear',
      arrows: false,
    };
    const checkIsApp = isApp();
    const offerDetailProps = {
      imgPath: image,
      title: imageTitle,
      desc: imageDesc,
      isNotClickableBanner: true,
    };
    const { isCustomerStateDisable, windowSize, isFetchingStage } = this.state;
    const isCtaButtonEnabled =
      !(isOffer && !isCtaEnabled) &&
      !isCustomerStateDisable &&
      !isFetchingStage;
    const formattedSubjectDesc = subjectDesc.replace(/\n/g, '<br>');

    const renderPriceListItem = (label, link, key = label) => (
      <a
        key={key}
        onClick={() => {
          this.onGaTaggingClick(cardViewId, subtitle, label);
          if (!link.includes('.pdf')) {
            window.open(link);
            return;
          }
          onDownloadDocument(link);
        }}
        className="my-privileges-details-view__price-list-link"
        data-enable-ga
        data-ga-type="link"
      >
        <img src={documentIcon} alt="price-list" />
        <span dangerouslySetInnerHTML={{ __html: memoSanitize(label) }}></span>
      </a>
    );

    return (
      <div>
        {isLoadingPage && <LoadingView key="GenericDetailsViewLoading" />}
        {isOffer && <OfferDetailBanner offerDetailBanner={offerDetailProps} />}
        <div
          className={
            isLoadingPage
              ? 'my-privileges-details-view emma-stylesheet-grid-system is-loading'
              : 'my-privileges-details-view emma-stylesheet-grid-system'
          }
        >
          <div className="my-privileges-details-view__wrap">
            {icon && (
              <div className="my-privileges-details-view__icon">
                <img src={icon} />
              </div>
            )}
            <div
              className={`my-privileges-details-view__title ${
                isOffer ? 'my-privileges-details-view-offer__title' : ''
              }`}
            >
              {subtitle && <div>{subtitle}</div>}
              {formattedSubjectDesc && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: memoSanitize(formattedSubjectDesc),
                  }}
                ></div>
              )}
              {supportDesc && <div>{supportDesc}</div>}
            </div>
          </div>

          {!!ctaBtnText && (
            <div
              className={`my-privileges-details-view__button-wrapper ${
                isOffer
                  ? 'my-privileges-details-view-offer__button-wrapper'
                  : ''
              }`}
            >
              {/* {isOffer && !isCtaButtonEnabled && <div className="my-privileges-details-view__btn-link my-privileges-details-view-disable__btn-link">{ctaBtnText}</div>} */}
              {/* {((isOffer && isCtaButtonEnabled) || !isOffer) && ctaBtnText && (<a tabIndex={0}
              className="my-privileges-details-view__btn-link test-btn"
              href={contactNumber ? `tel:${contactNumber}` : "javascript:;"}
              onClick={() => {
               this.onClickToGatc(cardViewId, ctaBtnText, subtitle);
               onClickTryNow(cardViewId, isLocked || false, { url, disclaimerId, disclaimerLockId, contactNumber, signalModel }, profileFeatures)
              }}
              data-enable-ga
              data-ga-type="link"
            >
              {ctaBtnText}
              <span hidden={!isLoadingCtnButton}><img className="loading-icon" src={loadingIcon} alt="" /></span>
            </a>)} */}
              <a
                tabIndex={0}
                href={contactNumber ? `tel:${contactNumber}` : 'javascript:;'}
                onClick={() => {
                  this.onClickToGatc(cardViewId, ctaBtnText, subtitle);
                  onClickTryNow(
                    cardViewId,
                    isLocked || false,
                    {
                      url,
                      disclaimerId,
                      disclaimerLockId,
                      contactNumber,
                      signalModel,
                    },
                    profileFeatures,
                  );
                }}
                data-enable-ga
                data-ga-type="link"
              >
                <SmallButton
                  isLoading={isLoadingCtnButton}
                  disabled={!isCtaButtonEnabled}
                >
                  {ctaBtnText}
                </SmallButton>
              </a>
            </div>
          )}
          {openingHoursDisplay && (
            <div
              className="my-privileges-details-view__opening-hour-display"
              dangerouslySetInnerHTML={{
                __html: memoSanitize(openingHoursDisplay),
              }}
            ></div>
          )}
          {isOffer && !isCtaButtonEnabled && isCustomerStateDisable && (
            <div className="my-privileges-details-view__already-enrolled">
              {alreadyEnrolled}
            </div>
          )}

          {isOffer && !isCtaButtonEnabled && !isCustomerStateDisable && (
            <div className="my-privileges-details-view__promotion-ended">
              {promotionEnded}
            </div>
          )}

          {(summary || summaryTitle) && (
            <Ellipses
              context={{
                title: summaryTitle,
                content: summary,
                more: more,
                less: less,
              }}
              key={Math.random()}
            ></Ellipses>
          )}

          {(!!priceListTitle ||
            !!priceListDesc ||
            !!priceListLink ||
            !!priceListLabel ||
            (!!priceLists && !!priceLists.length)) && (
            <div className="my-privileges-details-view__price-list">
              {priceListTitle && (
                <div
                  className="my-privileges-details-view__price-list-title"
                  dangerouslySetInnerHTML={{
                    __html: memoSanitize(priceListTitle),
                  }}
                ></div>
              )}
              {priceListDesc && (
                <div
                  className="my-privileges-details-view__price-list-desc"
                  dangerouslySetInnerHTML={{
                    __html: memoSanitize(priceListDesc),
                  }}
                ></div>
              )}
              <div className="d-flex flex-column">
                {priceLists.map(({ label, link }) =>
                  renderPriceListItem(label, link),
                )}
                {priceListLink &&
                  priceListLabel &&
                  renderPriceListItem(priceListLabel, priceListLink)}
              </div>
            </div>
          )}

          {banner.length > 0 && (
            <div className="my-privileges-details-view__carousel">
              <div className="emma-carousel emma-deprecated-slick">
                <Slider {...defaultSettings}>
                  {banner.map((value: any, index: number) => {
                    const videoUrl = resolveLocalizedText(value.videoUrl);
                    const youtubeId = resolveLocalizedText(value.youtubeId);
                    return (
                      <div key={index} className="emma-carousel__outer">
                        {value.src && (
                          <div
                            className="emma-carousel__inner"
                            style={{
                              backgroundImage: `url(${
                                windowSize === WINDOW_SIZE.SMALL &&
                                value.smallViewportSrc
                                  ? value.smallViewportSrc
                                  : value.src
                              })`,
                            }}
                          />
                        )}
                        {!!(videoUrl || youtubeId) && (
                          <div className="emma-carousel__inner">
                            <MediaPlayer
                              {...{
                                height: '250',
                                lang,
                                details: {
                                  uuid: uuidv4(),
                                  title: resolveLocalizedText(value.caption),
                                  videoUrl,
                                  youtubeId,
                                },
                                currentAudioplayerTimes: 0,
                                onFetchAudioplayer: () => {},
                                onPlay: () => {
                                  const { hideBannerCaption } = this.state;
                                  hideBannerCaption[index] = true;
                                  this.setState(hideBannerCaption);
                                },
                              }}
                            />
                          </div>
                        )}
                        {value.caption && (
                          <div
                            className="emma-carousel__caption"
                            style={
                              this.state.hideBannerCaption[index]
                                ? { display: 'none' }
                                : {}
                            }
                          >
                            {resolveLocalizedText(value.caption)}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>
          )}

          <div className="my-privileges-details-view__introduce-container">
            {section &&
              section.map((value: any, index: number) => {
                return (
                  <div key={index}>
                    <div
                      className="my-privileges-details-view__introduce"
                      key={index}
                    >
                      {value.title && (
                        <div
                          className="my-privileges-details-view__introduce-title"
                          dangerouslySetInnerHTML={{
                            __html: memoSanitize(value.title),
                          }}
                        ></div>
                      )}
                      {value.alertBox && (
                        <div
                          className={classNames(EmmaSpace.mt8, EmmaSpace.mb8)}
                        >
                          <EmmaListWithIcon
                            icon={
                              <EmmaIcon
                                iconKey="functional/alert"
                                width={24}
                                height={24}
                              />
                            }
                            text={
                              <div
                                className={
                                  EmmaText['BodyTextS/line-15em/Left/MineShaft']
                                }
                              >
                                {value.alertBox}
                              </div>
                            }
                            space={EmmaSpace.pr8}
                            alignItems="start"
                            backgroundColor="support3"
                            textStyling="none"
                            rounded
                          />
                        </div>
                      )}
                      {value.subTitle && (
                        <div
                          className={classNames(
                            EmmaText['Title_L/ComplexContent/Left/MineShaft'],
                            EmmaSpace.mb4,
                          )}
                          dangerouslySetInnerHTML={{
                            __html: memoSanitize(value.subTitle),
                          }}
                        ></div>
                      )}
                      {value.serviceSection && (
                        <ServiceSection
                          context={value.serviceSection}
                          onClickModuleCard={onClickModuleCard}
                        ></ServiceSection>
                      )}
                      {value.desc && (
                        <div
                          className="my-privileges-details-view__introduce-desc"
                          dangerouslySetInnerHTML={{
                            __html: memoSanitize(value.desc),
                          }}
                        ></div>
                      )}
                    </div>
                    {value.dropdownSection && (
                      <Dropdown
                        context={value.dropdownSection}
                        onClickModuleCard={onClickModuleCard}
                      ></Dropdown>
                    )}
                    <MyPrivilegesModalView
                      featureId={this.props.featureId}
                      dropdownSection={value.dropdownSection}
                      serviceSection={value.serviceSection}
                    />
                  </div>
                );
              })}
          </div>

          {!!serviceTitle && (
            <div
              className="my-privileges-details-view__service-title"
              dangerouslySetInnerHTML={{ __html: memoSanitize(serviceTitle) }}
            ></div>
          )}

          {serviceCards.map((card, index) => {
            return (
              <div
                key={`serviceCard${index}`}
                className="my-privileges-details-view__service-card"
              >
                {icon && (
                  <img
                    className="my-privileges-details-view__service-card-icon"
                    src={card.icon}
                  />
                )}
                <div className="my-privileges-details-view__service-card-content">
                  <span className="my-privileges-details-view__service-card-content-title">
                    {card.title}
                  </span>
                  <span className="my-privileges-details-view__service-card-content-desc">
                    {card.desc}
                  </span>
                </div>
                <div
                  className="my-privileges-details-view__service-card-link"
                  data-enable-ga
                  data-ga-type="link"
                  onClick={() => {
                    goto(card.deepLink);
                  }}
                >
                  <span>{card.buttonText}</span>
                  <img src={blueArrowRightIcon} />
                </div>
              </div>
            );
          })}
          {(buttonRemarkTitle ||
            buttonRemarkContent ||
            buttonRemarkIcon ||
            buttonRemarkBtnText ||
            buttonRemarkDeepLink) && (
            <div className="my-privileges-details-view__button-remark">
              {!!buttonRemarkTitle && (
                <span className="my-privileges-details-view__button-remark-title">
                  {buttonRemarkTitle}
                </span>
              )}
              {!!buttonRemarkContent && (
                <span className="my-privileges-details-view__button-remark-content">
                  {buttonRemarkContent}
                </span>
              )}
              {(buttonRemarkBtnText || buttonRemarkIcon) && (
                <div
                  className="my-privileges-details-view__button-remark-card"
                  onClick={() => {
                    goto(buttonRemarkDeepLink);
                  }}
                  data-enable-ga
                  data-ga-type="button"
                >
                  <div className="my-privileges-details-view__button-remark-card-content">
                    {!!buttonRemarkIcon && <img src={buttonRemarkIcon} />}
                    {!!buttonRemarkBtnText && (
                      <span>{buttonRemarkBtnText}</span>
                    )}
                  </div>
                  <img src={greyArrowRightIcon} />
                </div>
              )}
            </div>
          )}
          {stepSection && (
            <div className="my-privileges-details-view__step-section">
              {stepSection.title && (
                <div className="my-privileges-details-view__step-section-title">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: memoSanitize(stepSection.title),
                    }}
                  ></div>
                </div>
              )}
              <div className="my-privileges-details-view__step-section-step">
                <Step context={stepSection}></Step>
              </div>
            </div>
          )}
          {stepSection2 && (
            <div className="my-privileges-details-view__step-section my-privileges-details-view__stepSection2">
              {stepSection2.title && (
                <div className="my-privileges-details-view__step-section-title">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: memoSanitize(stepSection2.title),
                    }}
                  ></div>
                </div>
              )}
              <div className="my-privileges-details-view__step-section-step">
                <Step context={stepSection2}></Step>
              </div>
            </div>
          )}
          <div
            className={`my-privileges-details-view__enquiry ${
              section.length === 0 && stepSection === '' && !checkIsApp
                ? 'my-privileges-details-view__enquiry_top'
                : ''
            }`}
          >
            {enquiry && (
              <div
                dangerouslySetInnerHTML={{ __html: memoSanitize(enquiry) }}
              ></div>
            )}
            {enquiryDesc && (
              <div>
                <span
                  dangerouslySetInnerHTML={{
                    __html: memoSanitize(enquiryDesc),
                  }}
                ></span>
                <span
                  className="tel"
                  onClick={() =>
                    this.onGaTaggingClick(cardViewId, subtitle, tel)
                  }
                  data-enable-ga
                  data-ga-type="link"
                >
                  <a href={`tel: +${String(tel).replace(/\(|\)/g, '')}`}>
                    {' '}
                    {tel}
                  </a>
                </span>
                {enquiryDesc2 && (
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: memoSanitize(enquiryDesc2),
                      }}
                    ></span>
                    <span
                      className="tel"
                      onClick={() =>
                        this.onGaTaggingClick(cardViewId, subtitle, 'Call')
                      }
                      data-enable-ga
                      data-ga-type="link"
                    >
                      <a href={`tel: +${String(tel2).replace(/\(|\)/g, '')}`}>
                        {' '}
                        {tel2}
                      </a>
                    </span>
                  </span>
                )}
                {enquiryDesc3 && (
                  <span
                    dangerouslySetInnerHTML={{
                      __html: memoSanitize(enquiryDesc3),
                    }}
                  ></span>
                )}
                {t('FULL_STOP')}
              </div>
            )}
          </div>

          <div className="my-privileges-details-view__termscondition">
            {/* {termsCondition && (<div dangerouslySetInnerHTML={{  __html: memoSanitize( termsCondition ) }}></div>)} */}
            {termsConditionDesc && (
              <div>
                <span>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: memoSanitize(termsConditionDesc),
                    }}
                  ></span>
                  <span className="tel">
                    <a
                      onClick={() => {
                        this.onGaTaggingClick(
                          cardViewId,
                          subtitle,
                          termsConditionTncDesc,
                        );
                        if (termsConditionTncId)
                          openEmmaTncStyleModel(termsConditionTncId);
                        else return;
                      }}
                      data-enable-ga
                      data-ga-type="button"
                    >
                      {' '}
                      {termsConditionTncDesc}
                    </a>
                  </span>
                  {termsConditionDesc2 && (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: memoSanitize(termsConditionDesc2),
                      }}
                    ></span>
                  )}
                  {termsConditionTncDesc2 && (
                    <span className="tel">
                      <a
                        onClick={() => {
                          this.onGaTaggingClick(
                            cardViewId,
                            subtitle,
                            termsConditionTncDesc2,
                          );
                          if (termsConditionTncId2)
                            openEmmaTncStyleModel(termsConditionTncId2);
                          else return;
                        }}
                        data-enable-ga
                        data-ga-type="button"
                      >
                        {' '}
                        {termsConditionTncDesc2}
                      </a>
                    </span>
                  )}
                  {termsConditionDesc3 && (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: memoSanitize(termsConditionDesc3),
                      }}
                    ></span>
                  )}
                </span>
              </div>
            )}
          </div>

          {morePrivileges && morePrivilegesBtnText && (
            <div className="my-privileges-details-view__more">
              <div
                className="my-privileges-details-view__more-title"
                dangerouslySetInnerHTML={{
                  __html: memoSanitize(morePrivileges),
                }}
              ></div>
              {morePrivilegesDesc && (
                <div
                  className="my-privileges-details-view__more-desc"
                  dangerouslySetInnerHTML={{
                    __html: memoSanitize(morePrivilegesDesc),
                  }}
                ></div>
              )}
              <div className="my-privileges-details-view__more-btn-wrapper">
                <a
                  onClick={() => {
                    this.onGaTaggingClick(
                      cardViewId,
                      subtitle,
                      morePrivilegesBtnText,
                    );
                    goto(`emma-my-privileges/${morePrivilegesTab}`);
                  }}
                >
                  <button
                    type="button"
                    className="my-privileges-details-view__more-btn emma-stylesheet-primary-ghost-button"
                    data-enable-ga
                    data-ga-type="button"
                  >
                    {morePrivilegesBtnText}
                  </button>
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: GenericDetailsViewProps) {
    let cardViewState = getCardViewPrivilegesState(
      state,
      ownProps.cardViewId,
      ownProps.reducerSubName,
    );
    if (Object.keys(cardViewState).length === 0) {
      cardViewState = getOfferCardViewPrivilegesState(
        state,
        ownProps.cardViewId,
      );
    }
    const myPrivilegesState: any = getIsLoadingCtnButtonState(state);

    const disclaimerId = _.get(
      cardViewState.deepLink,
      'query.disclaimer',
      undefined,
    );
    const disclaimerLockId = _.get(
      cardViewState.deepLinkLock,
      'query.disclaimer',
      undefined,
    );
    let url: string = resolveLocalizedText(
      _.get(cardViewState.deepLink, 'query.url', {}),
    );
    if (url) {
      url = url.replace('${policyType}', 'betterme');
    }
    const btnText: string = resolveLocalizedText(
      _.get(cardViewState.deepLink, 'query.label', {}),
    );
    const contactNumber: string = _.get(
      cardViewState.deepLink,
      'query.contactNumber',
    );

    const profileFeatures = isCWP(state)
      ? undefined
      : (getProfileFeatures(state) || []).slice();

    const privilegesDetailsConverted = parsePrivilegesDetails(cardViewState);
    const privilegesDetails: PrivilegesDetailsProps = {
      ...privilegesDetailsConverted,
      contactNumber: contactNumber ? contactNumber : undefined,
      customerStateUrl: getCustomerStateUrl(state),
      disclaimerId: disclaimerId,
      disclaimerLockId: disclaimerLockId,
      url: url,
      btnText: btnText,
      profileFeatures: profileFeatures,
      isLoadingCtnButton: myPrivilegesState.isLoadingCtnButton,
      isLoadingPage: myPrivilegesState.isLoadingPage,
    };
    return {
      featureId: ownProps.cardViewId,
      privilegesDetails,
    };
  }

  static mapDispatchToProps(dispatch: any, ownProps: GenericDetailsViewProps) {
    return {
      onPushTitle: (title: string) => dispatch(pushTitle(title)),
      onClickTryNow: (
        cardViewId: string,
        isLocked: boolean,
        obj: {
          url: string;
          disclaimerId?: string;
          disclaimerLockId?: string;
          contactNumber?: string;
          signalModel?: string;
        },
        profileFeatures?: Array<string>,
      ) => {
        const {
          url,
          disclaimerId,
          disclaimerLockId,
          contactNumber,
          signalModel,
        } = obj;
        dispatch(triggerCTAButton(cardViewId));
        if (contactNumber) {
          return;
        } else if (isLocked && disclaimerLockId) {
          dispatch(openDisclaimer(disclaimerLockId));
        } else if (isLocked) {
          return;
        } else if (disclaimerId) {
          if (disclaimerId.includes('AppointmentContactCall')) {
            dispatch(
              putOpenEmmaContactCallModel({
                disclaimerId,
                onCloseCallBack: () => {
                  const tcWindow: any = window;
                  const token = select(getToken);
                  const aToken = getValidToken(token);
                  const close = t('CLOSE') || '';
                  // ga#18
                  try {
                    tcWindow.dataLayer.push({
                      event: 'clickClose',
                      serviceName: cardViewId,
                      serviceId: cardViewId,
                      displayedButtonText: close,
                      screenName: getGaPagePath(),
                      userId: aToken,
                    });

                    // HKEMMA-100917 - GA3 Decommission - Remove GA3
                    // if (!isApp()) {
                    //   tcWindow.tC.event.clickClose(tcWindow, {
                    //     serviceName: cardViewId,
                    //     serviceId: cardViewId,
                    //     displayedButtonText: close,
                    //     screenName: getGaPagePath(),
                    //     AXAID: aToken,
                    //   });
                    // }
                  } catch (e) {
                    handleGaError(e);
                  }
                },
              }),
            );
          } else {
            dispatch(openMyPrivilegesDisclaimer(disclaimerId, cardViewId));
          }
        } else if (
          (cardViewId === 'hkshwellnessexperience' ||
            cardViewId === 'chronicdiseasemanagement' ||
            cardViewId === 'jadediabetes') &&
          profileFeatures &&
          !profileFeatures.includes('myagents')
        ) {
          goto('emma-life/generic-support');
        } else if (GeneralFeatureIds.includes(cardViewId)) {
          const offersData = {
            infoObj: {
              name: '',
              gender: '',
              birthday: '',
              email: '',
              mobileCountryCode: '852',
              mobile: '',
              consultantMobileCountryCode: '852',
              consultantMobile: '',
              product: '',
              promotionCode: '',
              agentCode: '',
            },
            dependentArr: [],
          };
          dispatch(updateOffersForm(offersData));
          dispatch(updateOffersFormResponse({ title: '', msg: '' }));
          goto('emma-free-offers');
        } else if (url) {
          dispatch(goTo(cardViewId, url));
        }
      },
      onClickModuleCard: (cardId: string) => {
        dispatch(toggleModelDisplay(true, cardId));
      },
      openEmmaTncStyleModel: (disclaimerId: string) => {
        dispatch(putOpenEmmaTncStyleModel(disclaimerId));
      },
      onDownloadDocument: (url: string) => dispatch(downloadDocument(url)),
      onEndLoadingPage: () => {
        dispatch(setPageNotLoading());
      },
      setPageLoading: () => {
        dispatch(setPageLoading());
      },
      onFetchDetailsPageInfo: () => {
        dispatch(fetchDetailsPageInfo(ownProps.cardViewId));
      },
    };
  }
}

const jsonResolveLocalized = (obj: any) => {
  // let objTem = {};
  for (const key in obj) {
    if (Array.isArray(obj[key])) {
      obj[key] = arrayResolveLocalized(obj[key]);
    } else {
      if (!resolveLocalizedText(obj[key]) && obj[key]) {
        obj[key] = jsonResolveLocalized(obj[key]);
      } else {
        obj[key] = obj[key] ? resolveLocalizedText(obj[key]) : '';
      }
    }
  }
  return obj;
};

const arrayResolveLocalized = (obj: Array<any>) => {
  obj.forEach((item: any) => {
    if (typeof item === 'object') {
      item = jsonResolveLocalized(item);
    }
  });
  return obj;
};
function parsePrivilegesDetails(cardViewState: any) {
  const section: CardViewPrivilegesSectionsState[] = JSON.parse(
    JSON.stringify(cardViewState.section || []),
  );
  section.map((section) => {
    if (section.dropdownSection && section.dropdownSection.optionResults) {
      section.dropdownSection.optionResults.map((result) => {
        result.icon =
          result && result.icon
            ? resolvePublicAssets(resolveLocalizedText(result.icon)).replace(
                '.png',
                '@3x.png',
              )
            : '';
      });
    }
  });
  return {
    title: cardViewState.title ? resolveLocalizedText(cardViewState.title) : '',
    subtitle: cardViewState.subtitle
      ? resolveLocalizedText(cardViewState.subtitle)
      : '',
    subjectDesc: cardViewState.subjectDesc
      ? resolveLocalizedText(cardViewState.subjectDesc)
      : '',
    supportDesc: cardViewState.supportDesc
      ? resolveLocalizedText(cardViewState.supportDesc)
      : '',
    ctaBtnText: cardViewState.ctaBtnText
      ? resolveLocalizedText(cardViewState.ctaBtnText)
      : '',
    openingHoursDisplay: cardViewState.openingHoursDisplay
      ? resolveLocalizedText(cardViewState.openingHoursDisplay)
      : '',
    summaryTitle: cardViewState.summaryTitle
      ? resolveLocalizedText(cardViewState.summaryTitle)
      : '',
    summary: cardViewState.summary
      ? resolveLocalizedText(cardViewState.summary)
      : '',
    more: cardViewState.more ? resolveLocalizedText(cardViewState.more) : '',
    less: cardViewState.less ? resolveLocalizedText(cardViewState.less) : '',
    enquiry: cardViewState.enquiry
      ? resolveLocalizedText(cardViewState.enquiry)
      : '',
    enquiryDesc: cardViewState.enquiryDesc
      ? resolveLocalizedText(cardViewState.enquiryDesc)
      : '',
    enquiryDesc2: cardViewState.enquiryDesc2
      ? resolveLocalizedText(cardViewState.enquiryDesc2)
      : '',
    enquiryDesc3: cardViewState.enquiryDesc3
      ? resolveLocalizedText(cardViewState.enquiryDesc3)
      : '',
    termsCondition: cardViewState.termsCondition
      ? resolveLocalizedText(cardViewState.termsCondition)
      : '',
    termsConditionDesc: cardViewState.termsConditionDesc
      ? resolveLocalizedText(cardViewState.termsConditionDesc)
      : '',
    termsConditionTncId:
      cardViewState.termsConditionTnc && cardViewState.termsConditionTnc.tncId
        ? cardViewState.termsConditionTnc.tncId
        : '',
    termsConditionTncDesc:
      cardViewState.termsConditionTnc && cardViewState.termsConditionTnc.label
        ? resolveLocalizedText(cardViewState.termsConditionTnc.label)
        : '',
    termsConditionDesc2: cardViewState.termsConditionDesc2
      ? resolveLocalizedText(cardViewState.termsConditionDesc2)
      : '',
    termsConditionTncId2:
      cardViewState.termsConditionTnc2 && cardViewState.termsConditionTnc2.tncId
        ? cardViewState.termsConditionTnc2.tncId
        : '',
    termsConditionTncDesc2:
      cardViewState.termsConditionTnc2 && cardViewState.termsConditionTnc2.label
        ? resolveLocalizedText(cardViewState.termsConditionTnc2.label)
        : '',
    termsConditionDesc3: cardViewState.termsConditionDesc3
      ? resolveLocalizedText(cardViewState.termsConditionDesc3)
      : '',
    banner: cardViewState.banner
      ? cardViewState.banner.map((banner: any) => {
          const newBanner: CardViewPrivilegesBannersState = {};
          banner && banner.src
            ? (newBanner.src = resolvePublicAssets(banner.src)
                .replace('.png', '@3x.png')
                .replace('.jpg', '@3x.jpg'))
            : (newBanner.src = '');
          banner && banner.videoUrl
            ? (newBanner.videoUrl = banner.videoUrl)
            : (newBanner.videoUrl = '');
          banner && banner.youtubeId
            ? (newBanner.youtubeId = banner.youtubeId)
            : (newBanner.youtubeId = '');
          banner && banner.smallViewportSrc
            ? (newBanner.smallViewportSrc = resolvePublicAssets(
                banner.smallViewportSrc,
              )
                .replace('.png', '@3x.png')
                .replace('.jpg', '@3x.jpg'))
            : (newBanner.smallViewportSrc = '');
          newBanner.caption = banner.caption;
          return newBanner;
        })
      : [],
    tel: cardViewState.tel ? resolveLocalizedText(cardViewState.tel) : '',
    tel2: cardViewState.tel2 ? resolveLocalizedText(cardViewState.tel2) : '',
    stepSection: cardViewState.stepSection
      ? jsonResolveLocalized(cardViewState.stepSection)
      : '',
    stepSection2: cardViewState.stepSection2
      ? jsonResolveLocalized(cardViewState.stepSection2)
      : '',
    section: section ? arrayResolveLocalized(section) : [],
    icon: cardViewState.icon
      ? resolvePublicAssets(cardViewState.icon).replace('.png', '@3x.png')
      : '',
    signalModel: cardViewState.signalModel
      ? cardViewState.signalModel
      : undefined,
    morePrivileges: cardViewState.morePrivileges
      ? resolveLocalizedText(cardViewState.morePrivileges)
      : '',
    morePrivilegesTab: cardViewState.morePrivilegesTab
      ? cardViewState.morePrivilegesTab
      : 'privileges-tab',
    morePrivilegesDesc: cardViewState.morePrivilegesDesc
      ? resolveLocalizedText(cardViewState.morePrivilegesDesc)
      : '',
    morePrivilegesBtnText: cardViewState.morePrivilegesBtnText
      ? resolveLocalizedText(cardViewState.morePrivilegesBtnText)
      : '',
    priceListTitle: cardViewState.priceListTitle
      ? resolveLocalizedText(cardViewState.priceListTitle)
      : '',
    priceListDesc: cardViewState.priceListDesc
      ? resolveLocalizedText(cardViewState.priceListDesc)
      : '',
    priceListLabel: cardViewState.priceListLabel
      ? resolveLocalizedText(cardViewState.priceListLabel)
      : '',
    priceLists: cardViewState.priceLists
      ? (cardViewState.priceLists ?? []).map(({ label, link }) => ({
          label: resolveLocalizedText(label),
          link: resolveLocalizedText(link),
        }))
      : [],
    isOffer: cardViewState.isOffer ? cardViewState.isOffer : false,
    isCtaEnabled: cardViewState.isCtaEnabled
      ? cardViewState.isCtaEnabled
      : false,
    image: cardViewState.image ? cardViewState.image : '',
    imageTitle: cardViewState.imageTitle
      ? resolveLocalizedText(cardViewState.imageTitle)
      : '',
    imageDesc: cardViewState.imageDesc
      ? resolveLocalizedText(cardViewState.imageDesc)
      : '',
    submittedFormKey: cardViewState.submittedForm,
    alreadyEnrolled: cardViewState.alreadyEnrolled
      ? resolveLocalizedText(cardViewState.alreadyEnrolled)
      : '',
    promotionEnded: cardViewState.promotionEnded
      ? resolveLocalizedText(cardViewState.promotionEnded)
      : '',
    serviceTitle: cardViewState.serviceTitle
      ? resolveLocalizedText(cardViewState.serviceTitle)
      : '',
    serviceCards: cardViewState.serviceCards
      ? cardViewState.serviceCards.map((card: any) => {
          const newCard: CardViewPrivilegesServiceCardState = {};
          card && card.icon
            ? (newCard.icon = resolvePublicAssets(card.icon)
                .replace('.png', '@3x.png')
                .replace('.jpg', '@3x.jpg'))
            : (newCard.icon = '');
          card && card.title
            ? (newCard.title = resolveLocalizedText(card.title))
            : (newCard.title = '');
          card && card.desc
            ? (newCard.desc = resolveLocalizedText(card.desc))
            : (newCard.desc = '');
          card && card.buttonText
            ? (newCard.buttonText = resolveLocalizedText(card.buttonText))
            : (newCard.buttonText = '');
          card && card.deepLink
            ? (newCard.deepLink = card.deepLink)
            : (newCard.deepLink = '');
          return newCard;
        })
      : [],
    buttonRemarkTitle: cardViewState?.buttonRemark?.title
      ? resolveLocalizedText(cardViewState.buttonRemark.title)
      : '',
    buttonRemarkContent: cardViewState?.buttonRemark?.content
      ? resolveLocalizedText(cardViewState.buttonRemark.content)
      : '',
    buttonRemarkIcon: cardViewState?.buttonRemark?.icon
      ? resolvePublicAssets(cardViewState.buttonRemark.icon)
      : '',
    buttonRemarkBtnText: cardViewState?.buttonRemark?.btnText
      ? resolveLocalizedText(cardViewState.buttonRemark.btnText)
      : '',
    buttonRemarkDeepLink: cardViewState?.buttonRemark?.deepLink || '',
  };
}
